<template>
  <div class="container">
    <div class="title" v-if="!id">请仔细阅读以下承诺书，确认同意后购买无限卡家庭卡。</div>
    <div class="content_view">
      <div class="content" v-if="!id">
        <div class="content_title">《友邻少年家庭卡购买协议》</div>
        <commitInfo :mergeData="receiverObj"></commitInfo>
      </div>
      <!-- 查看承诺书 -->
      <div v-else class="commitmentUrl_box">
        <img :src="commitmentObj.commitmentUrl" alt="" />
      </div>
    </div>
    <div :style="`width:100%;height:${domHeight}px;`"></div>
    <div class="bottom_btn_box" v-if="!id">
      <div class="need_user_box">
        <!-- 使用人 -->
        <ul class="flexbox tag_box">
          <div class="sure_box">家庭号使用人（单选）</div>
          <li v-for="(item, index) in usertags" :key="index" class="flexbox sure_box" @click="usertagFun(item, index)">
            <img v-if="!item.checked" src="../../../../images/subVIp/no.png" alt="" />
            <img v-else src="../../../../images/subVIp/yes.png" alt="" />
            {{ item.name }}
          </li>
        </ul>
        <!-- 协议 -->
        <div class="flexbox sure_box" @click="userCheckFun">
          <img v-if="!userCheck" src="../../../../images/subVIp/no.png" alt="" />
          <img v-else src="../../../../images/subVIp/yes.png" alt="" />
          本人已知晓并认可无限卡家庭卡购买协议
        </div>
      </div>
      <div class="btn_1_box">
        <div class="btn_box" @click="getPoster" :class="userCheck && useTagIndex !== null ? '' : 'opacityClass'">
          确认购买无限卡家庭卡
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commitInfo from './components/noSend.vue'
import { appUser, base64ToBlob, compressImg } from '@/utils'
import { Toast } from 'vant'
import html2canvas from 'html2canvas'
import { mapGetters } from 'vuex'

export default {
  components: {
    commitInfo
  },
  data() {
    return {
      title: '友邻少年',
      receiverObj: {
        status: -1
      },
      userCheck: false,
      useTagIndex: null,
      id: null,
      domHeight: 100,
      usertags: [
        {
          name: '配偶',
          type: 2,
          checked: false
        },
        {
          name: '子女',
          type: 1,
          checked: false
        }
      ]
    }
  },
  computed: {
    ...mapGetters('goods/vip', ['commitmentObj'])
  },
  created() {
    this.id = this.$route.query.id || null
    if (!this.id) {
      this.receiverObj = {
        userId: appUser.userId,
        status: -1
      }
    }
  },
  mounted() {
    const bottom = document.querySelector('.bottom_btn_box')
    if (bottom) this.domHeight = bottom.clientHeight
  },
  methods: {
    // 获取承诺书截图
    getPoster() {
      if (this.useTagIndex === null) return Toast('请先选择家庭号使用人')
      if (!this.userCheck) return Toast('请先确认同意无限卡购买协议')
      Toast.loading({
        duration: 0, // 持续展示 toast
        message: '承诺书上传中...',
        forbidClick: true
      })
      const capture = document.querySelector('.content_view')
      html2canvas(capture, {
        useCORS: true,
        width: capture.offsetWidth,
        height: capture.offsetHeight,
        scale: 2
      })
        .then(canvas => {
          const image = canvas.toDataURL('image/png')
          compressImg(image, 0.9, 1, '仅供友邻认证', res => {
            const base64 = res.split(',')[1]
            base64ToBlob({ b64data: base64, contentType: 'image/png' }).then(res => {
              this.upLoad(res)
            })
          })
        })
        .catch(() => {
          Toast.clear()
        })
    },
    upLoad(src) {
      this.$store
        .dispatch('goods/vip/imageTokenH5', {})
        .then(data => {
          this.$store.dispatch('goods/vip/uploadAliyun', { data, src }).then(res => {
            console.log('承诺书截图:', res)
            this.$store.commit('goods/vip/saveCommitmentDetails', {
              commitmentUrl: res,
              receiverIdentity: this.useTagIndex
            })
            this.$router.push({
              path: 'subVip-submitDetails',
              query: {
                id: this.id
              }
            })
            Toast.clear()
          })
        })
        .catch(err => {
          console.log('获取pocily err', err)
          Toast.clear()
          this.$toast({
            message: '我开小差了，请刷新重试'
          })
        })
    },

    usertagFun(item) {
      this.usertags.forEach(child => {
        if (item.name === child.name) child.checked = true
        else child.checked = false
      })
      this.useTagIndex = item.type
    },
    userCheckFun() {
      this.userCheck = !this.userCheck
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  min-height: 100%;
  background: #f7f9fb;
  padding: 0.48rem 0.32rem 0;
  .title {
    margin-bottom: 0.42rem;
    font-size: 0.28rem;
    font-weight: 600;
    color: #000000;
  }
  .content_view {
    background: #ffffff;
    padding: 0.16rem 0.16rem;
    border-radius: 0.16rem;
    .commitmentUrl_box {
      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }
    .content {
      margin: 0.16rem;
      padding: 0.54rem 0.28rem 1.2rem;
      border: 1px solid #e4e4e4;
      .content_title {
        font-size: 0.34rem;
        font-weight: 500;
        color: #000000;
        text-align: center;
        font-weight: 600;
        margin-bottom: 0.8rem;
      }
    }
  }
  .opacityClass {
    opacity: 0.6;
  }
  .bottom_btn_box {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;

    background: #ffffff;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    .need_user_box {
      background-color: #f7f9fb;
      padding: 0.4rem 0 0.53rem;
      box-shadow: 0rem 0.04rem -0.2rem 0rem rgba(0, 0, 0, 0.08);
    }
    .tag_box {
      margin-bottom: 0.39rem;
    }
    .sure_box {
      font-size: 0.26rem;
      font-weight: 400;
      color: #000000;
      padding-left: 0.5rem;
      img {
        display: block;
        width: 0.32rem;
        height: 0.32rem;
        margin-right: 5px;
      }
    }
    .btn_box {
      width: 6.54rem;
      height: 0.88rem;
      background: #00b25a;
      border-radius: 0.08rem;
      font-size: 0.32rem;
      font-weight: 600;
      color: #ffffff;
      text-align: center;
      line-height: 0.88rem;
      margin: 0.32rem auto 0.32rem;
    }
  }
}
</style>
